module.exports = __webpack_public_path__ + "img/step3-2.45f27703.png";